<template>
  <div>
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>

    <div class="note-container" style="font-family: 'Poppins', sans-serif; overflow-y: auto;">
      <div class="create-order" style="min-width: 1200px;">
        <div class="left">
          <h3 class="order-type">Incidencia: {{ incidentNumberDisplay }}</h3>
        </div>
        <div class="right">
          <button type="button" @click="backIncidents">Volver</button>
        </div>
      </div>

      <div class="main-data-container" style="min-width: 1200px;">
        <div class="maintenance-main">
        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Información General</h4>
          </div>
          <div class="container-card-body">
            <div class="maintenance-general-grid">
              <div class="maintenance-column">
                <div class="form-input-group">
                  <label>Unidad:</label>
                  <select v-model="localIncident.unit" :class="{ invalid: validationErrors.unit }">
                    <option value="">Seleccione</option>
                    <option v-for="u in units" :key="u.unit_id" :value="u.id">
                      {{ u.unit_short_id }} - {{ u.unit_plates }}
                    </option>
                  </select>
                </div>
                <div class="form-input-group">
                  <label>Empresa:</label>
                  <select v-model="localIncident.company">
                    <option value="">Seleccione</option>
                    <option v-for="owner in owners" :key="owner.id" :value="owner.id">
                      {{ owner.owner }}
                    </option>
                  </select>
                </div>
                <div class="form-input-group">
                  <label>Operador:</label>
                  <select v-model="localIncident.operator">
                    <option value="">Seleccione</option>
                    <option v-for="emp in operatorEmployees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>
                <div class="form-input-group">
                  <label>Dirección:</label>
                  <input type="text" v-model="localIncident.incident_address" />
                </div>
                <div class="form-input-group">
                  <label>No. Orden Reparación:</label>
                  <input type="text" v-model="localIncident.repair_order_number" />
                </div>
              </div>

              <div class="maintenance-column">
                <div class="form-input-group">
                  <label>Tipo de accidente:</label>
                  <input type="text" v-model="localIncident.accident_type" />
                </div>
                <div class="form-input-group">
                  <label>División:</label>
                  <input type="text" v-model="localIncident.division" />
                </div>
                <div class="form-input-group">
                  <label>Quién pagó:</label>
                  <input type="text" v-model="localIncident.who_paid" />
                </div>
                <div class="form-input-group">
                  <label>Vo. Bueno:</label>
                  <select v-model="localIncident.signed_off_by">
                    <option value="">Seleccione</option>
                    <option v-for="emp in employees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-input-group full-width">
              <label>Descripción:</label>
              <textarea v-model="localIncident.accident_description" :class="{ invalid: validationErrors.accident_description }"></textarea>
            </div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Persona afectada</h4>
          </div>
          <div class="container-card-body">
            <div class="form-input-group full-width">
              <label>Nombre:</label>
              <input type="text" v-model="localIncident.affected_person_name" />
            </div>
            <div class="form-input-group full-width">
              <label>Teléfono:</label>
              <input type="text" v-model="localIncident.affected_person_phone" />
            </div>
            <div class="form-input-group full-width">
              <label>Email:</label>
              <input type="text" v-model="localIncident.affected_person_email" />
            </div>
            <div class="form-input-group full-width">
              <label>Dirección:</label>
              <input type="text" v-model="localIncident.affected_person_address" />
            </div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Autoridades involucradas</h4>
            <button type="button" class="mini-action" @click="addAuthority">Agregar</button>
          </div>
          <div class="container-card-body">
            <div v-for="(authority, index) in authorities" :key="`authority-${index}`" class="list-row">
              <div class="form-input-group">
                <label>Autoridad:</label>
                <input type="text" v-model="authority.authority" />
              </div>
              <div class="form-input-group">
                <label>Comentarios:</label>
                <input type="text" v-model="authority.comments" />
              </div>
              <button type="button" class="mini-delete" @click="removeAuthority(index)">✕</button>
            </div>
            <div v-if="!authorities.length" class="empty-row">No hay autoridades registradas.</div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Daños reportados</h4>
            <button type="button" class="mini-action" @click="addDamage">Agregar</button>
          </div>
          <div class="container-card-body">
            <div v-for="(damage, index) in damagesList" :key="`damage-${index}`" class="list-row">
              <div class="form-input-group">
                <label>Tipo:</label>
                <input type="text" v-model="damage.type" />
              </div>
              <div class="form-input-group">
                <label>Comentarios:</label>
                <input type="text" v-model="damage.comments" />
              </div>
              <button type="button" class="mini-delete" @click="removeDamage(index)">✕</button>
            </div>
            <div v-if="!damagesList.length" class="empty-row">No hay daños registrados.</div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Evidencias y Documentos</h4>
            <button type="button" class="mini-action" @click="downloadAllIncidentFiles">Descargar todo</button>
          </div>
          <div class="container-card-body">
            <div class="media-section">
              <div class="media-header">
                <h5>Imágenes</h5>
              </div>
              <div class="media-grid">
                <button
                  type="button"
                  class="media-card media-add"
                  @click="uploadIncidentFile('image')"
                  :disabled="uploadingMedia || !incidentObjectId"
                >
                  <span class="media-plus">+</span>
                  <span class="media-add-label">{{ uploadingMedia ? 'Subiendo...' : 'Agregar imagen' }}</span>
                </button>

                <div class="media-card" v-for="item in imageFiles" :key="item.file_id">
                  <img :src="item.preview_url" :alt="item.title || item.file_name" class="media-preview" />
                  <div class="media-meta">
                    <h6>{{ item.title || 'Sin título' }}</h6>
                    <p>{{ item.description || 'Sin descripción' }}</p>
                  </div>
                  <div class="media-actions">
                    <button type="button" class="mini-action media-btn" @click="openFile(item)">Ver</button>
                    <button type="button" class="mini-action media-btn" @click="downloadFile(item)">Descargar</button>
                    <button type="button" class="mini-delete media-btn" @click="deleteIncidentFile(item.file_id)">Eliminar</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="media-section">
              <div class="media-header">
                <h5>Documentos</h5>
              </div>
              <div class="media-grid">
                <button
                  type="button"
                  class="media-card media-add"
                  @click="uploadIncidentFile('document')"
                  :disabled="uploadingMedia || !incidentObjectId"
                >
                  <span class="media-plus">+</span>
                  <span class="media-add-label">{{ uploadingMedia ? 'Subiendo...' : 'Agregar documento' }}</span>
                </button>

                <div class="media-card" v-for="item in documentFiles" :key="item.file_id">
                  <div class="media-doc-icon">DOC</div>
                  <div class="media-meta">
                    <h6>{{ item.title || item.file_name || 'Documento' }}</h6>
                    <p>{{ item.description || 'Sin descripción' }}</p>
                  </div>
                  <div class="media-actions">
                    <button type="button" class="mini-action media-btn" @click="openFile(item)">Abrir</button>
                    <button type="button" class="mini-action media-btn" @click="downloadFile(item)">Descargar</button>
                    <button type="button" class="mini-delete media-btn" @click="deleteIncidentFile(item.file_id)">Eliminar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <div class="maintenance-side">
          <div class="container-card">
            <div class="title">
              <h4>Deductibles</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Daño material:</label>
                <input type="number" min="0" v-model.number="localIncident.material_damage" />
              </div>
              <div class="form-input-group">
                <label>Resp. civil:</label>
                <input type="number" min="0" v-model.number="localIncident.civil_liability" />
              </div>
              <div class="form-input-group">
                <label>Resp. limitada:</label>
                <input type="number" min="0" v-model.number="localIncident.limited_liability" />
              </div>
              <div class="form-input-group full-width">
                <label>Comentarios deducible:</label>
                <textarea v-model="localIncident.deductible_comments"></textarea>
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Daños</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Daño estimado:</label>
                <input type="number" min="0" v-model.number="localIncident.estimated_damage" />
              </div>
              <div class="form-input-group">
                <label>Daño real:</label>
                <input type="number" min="0" v-model.number="localIncident.real_damage" />
              </div>
              <div class="form-input-group">
                <label>Veredicto:</label>
                <input type="text" v-model="localIncident.veredict" />
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Resolución</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Tiempo de resolución:</label>
                <input type="datetime-local" v-model="localIncident.resolution_time" />
              </div>
              <div class="form-input-group">
                <label>Quién resolvió:</label>
                <input type="text" v-model="localIncident.who_resolved" />
              </div>
              <div class="form-input-group full-width">
                <label>Resolución:</label>
                <textarea v-model="localIncident.resolution_description"></textarea>
              </div>
              <div class="form-input-group full-width">
                <label>Comentarios resolución:</label>
                <textarea v-model="localIncident.resolution_comments"></textarea>
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Datos del sistema</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Estatus:</label>
                <span :class="incidentStatusClass">{{ incidentStatusLabel }}</span>
              </div>
              <div class="form-input-group">
                <label>Capturista:</label>
                <input type="text" :value="capturistaName" disabled />
              </div>
              <div class="form-input-group">
                <label>Solicitud:</label>
                <input type="datetime-local" :value="formatDatetime(localIncident.request_time)" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions" style="min-width: 1200px;">
        <button
          v-if="canUpdate"
          type="button"
          class="btn-submit-save"
          @click="saveIncident"
          :disabled="saving"
        >
          {{ saving ? 'Guardando...' : 'Guardar' }}
        </button>
        <button
          v-if="canComplete"
          type="button"
          class="btn-submit-save btn-complete"
          @click="completeIncident"
          :disabled="saving"
        >
          Completar
        </button>
        <button type="button" class="btn-submit-cancel" @click="backIncidents">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Compressor from 'compressorjs'

export default {
  name: 'EditIncidentForm',
  props: {
    incidentDetails: { type: Object, default: () => ({}) },
    incidentId: { type: [String, Number], default: null },
    username: { type: String, default: '' },
    user_id: { type: [String, Number], default: null },
    user_groups: { type: Array, default: () => [] },
  },
  data() {
    return {
      permissions: [],
      localIncident: {},
      authorities: [],
      damagesList: [],
      validationErrors: {
        unit: false,
        accident_description: false,
      },
      employees: [],
      operatorEmployees: [],
      units: [],
      owners: [],
      saving: false,
      imageFiles: [],
      documentFiles: [],
      uploadingMedia: false,
    }
  },
  computed: {
    canUpdate() {
      return this.permissions.includes('maintenance.update_incident') ||
        this.permissions.includes('access_control.maintenance.update_incident')
    },
    canComplete() {
      return this.permissions.includes('maintenance.complete_incident') ||
        this.permissions.includes('access_control.maintenance.complete_incident')
    },
    incidentStatusLabel() {
      if (this.localIncident.incident_status === 2) return 'Solucionado'
      if (this.localIncident.incident_status === 1) return 'Pendiente'
      return this.localIncident.incident_status_label || 'Pendiente'
    },
    incidentStatusClass() {
      return this.localIncident.incident_status === 2 ? 'status status--ok' : 'status status--warn'
    },
    capturistaName() {
      if (this.localIncident.data_entry_clerk_name) {
        return this.localIncident.data_entry_clerk_name
      }
      const id = this.localIncident.data_entry_clerk ? Number(this.localIncident.data_entry_clerk) : null
      const emp = this.employees.find((item) => item.id === id)
      if (!id) return 'N/A'
      if (!emp) return `Empleado ${id}`
      return `${emp.employee_first_name} ${emp.employee_last_name}`.trim()
    },
    incidentNumberDisplay() {
      return this.localIncident.incident_number || this.localIncident.id || this.incidentId || 'N/A'
    },
    incidentObjectId() {
      const id = this.localIncident.id || this.incidentId
      return id ? String(id) : ''
    },
  },
  mounted() {
    this.loadPermissions()
    this.initializeLocalIncident(this.incidentDetails)
    this.fetchEmployees()
    this.fetchOperatorEmployees()
    this.fetchUnits()
    this.fetchOwners()
    this.fetchIncidentFiles()
  },
  watch: {
    incidentDetails: {
      deep: true,
      handler(newVal) {
        this.initializeLocalIncident(newVal)
      },
    },
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    initializeLocalIncident(data) {
      this.localIncident = { ...data }
      if (!this.localIncident.id && this.incidentId) {
        this.localIncident.id = Number(this.incidentId)
      }
      this.localIncident.resolution_time = this.formatDatetime(data.resolution_time)
      this.authorities = this.normalizeList(data.authorities_involved, ['authority', 'comments'])
      this.damagesList = this.normalizeList(data.damages, ['type', 'comments'])
    },
    backMainPanel() {
      this.$router.push('/main-panel')
    },
    backIncidents() {
      this.$router.push('/unit-incidents')
    },
    formatDatetime(value) {
      if (!value) return ''
      return value.slice(0, 16)
    },
    normalizeList(value, keys) {
      if (Array.isArray(value)) {
        return value.map((item) => {
          const normalized = {}
          keys.forEach((key) => {
            normalized[key] = (item && item[key]) || ''
          })
          return normalized
        })
      }
      if (value && Array.isArray(value.items)) {
        return value.items.map((item) => {
          const normalized = {}
          keys.forEach((key) => {
            normalized[key] = (item && item[key]) || ''
          })
          return normalized
        })
      }
      return [{ [keys[0]]: '', [keys[1]]: '' }]
    },
    addAuthority() {
      this.authorities.push({ authority: '', comments: '' })
    },
    removeAuthority(index) {
      this.authorities.splice(index, 1)
      if (!this.authorities.length) {
        this.authorities.push({ authority: '', comments: '' })
      }
    },
    addDamage() {
      this.damagesList.push({ type: '', comments: '' })
    },
    removeDamage(index) {
      this.damagesList.splice(index, 1)
      if (!this.damagesList.length) {
        this.damagesList.push({ type: '', comments: '' })
      }
    },
    sanitizeList(list, keys) {
      const cleaned = list
        .map((item) => {
          const trimmed = {}
          keys.forEach((key) => {
            trimmed[key] = (item[key] || '').toString().trim()
          })
          return trimmed
        })
        .filter((item) => keys.some((key) => item[key]))
      return cleaned.length ? cleaned : null
    },
    async fetchEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.post(`${apiDirectory}/get-employee?page=1&page_size=200`, {})
        this.employees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching employees:', error)
      }
    },
    async fetchOperatorEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/operators-for-forms`)
        this.operatorEmployees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching operator employees:', error)
      }
    },
    async fetchUnits() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/units-for-forms`)
        this.units = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching units:', error)
      }
    },
    async fetchOwners() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/get-owners`)
        this.owners = response.data || []
      } catch (error) {
        console.error('There was an error fetching owners:', error)
      }
    },
    async fetchIncidentFiles() {
      const objectId = this.incidentObjectId
      if (!objectId) return
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/get-files/`, {
          params: { object_type: 'unit_incident', object_id: objectId },
        })
        const files = Array.isArray(response.data) ? response.data : []
        this.imageFiles = []
        this.documentFiles = []
        files.forEach((file) => {
          const metadata = file.metadata || {}
          const mimeType = metadata.file_type || ''
          const category = metadata.category || (mimeType.startsWith('image/') ? 'image' : 'document')
          const item = {
            file_id: file.file_id,
            title: metadata.title || '',
            description: metadata.description || '',
            file_name: metadata.file_name || '',
            mime_type: mimeType,
            preview_url: `data:${mimeType || 'application/octet-stream'};base64,${file.content}`,
          }
          if (category === 'image') this.imageFiles.push(item)
          else this.documentFiles.push(item)
        })
      } catch (error) {
        // The endpoint answers 404 when the incident has no files yet
        if (error?.response?.status !== 404) {
          console.error('Error fetching incident files:', error)
        }
        this.imageFiles = []
        this.documentFiles = []
      }
    },
    selectFile(accept) {
      return new Promise((resolve) => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = accept
        input.onchange = (event) => resolve(event.target.files?.[0] || null)
        input.click()
      })
    },
    getProportionalCompressionQuality(size) {
      const maxSize = 10000000
      const minQuality = 0.4
      const maxQuality = 0.9
      return Math.max(minQuality, Math.min(maxQuality, maxQuality - (size / maxSize) * (maxQuality - minQuality)))
    },
    compressAndConvertToJPG(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: this.getProportionalCompressionQuality(file.size),
          convertSize: 5000000,
          success(result) {
            resolve(new File([result], 'image.jpg', { type: 'image/jpeg' }))
          },
          error(err) {
            reject(err)
          },
        })
      })
    },
    async uploadIncidentFile(category) {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la incidencia.', 'warning')
        return
      }
      const objectId = this.incidentObjectId
      if (!objectId) {
        Swal.fire('Error', 'No se encontró el identificador de la incidencia.', 'error')
        return
      }
      try {
        const file = await this.selectFile(category === 'image' ? 'image/*' : '*/*')
        if (!file) return

        const metadataPrompt = await Swal.fire({
          title: 'Detalles del archivo',
          html: `
            <input id="incident-file-title" class="swal2-input" placeholder="Título" value="${file.name.replace(/"/g, '&quot;')}">
            <textarea id="incident-file-description" class="swal2-textarea" placeholder="Descripción"></textarea>
          `,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'Subir',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            const title = document.getElementById('incident-file-title')?.value?.trim() || ''
            const description = document.getElementById('incident-file-description')?.value?.trim() || ''
            if (!title) {
              Swal.showValidationMessage('El título es obligatorio')
              return null
            }
            return { title, description }
          },
        })
        if (!metadataPrompt.isConfirmed || !metadataPrompt.value) return

        this.uploadingMedia = true
        const uploadedFile = category === 'image' ? await this.compressAndConvertToJPG(file) : file

        const formData = new FormData()
        formData.append('file', uploadedFile)
        formData.append('object_type', 'unit_incident')
        formData.append('object_id', objectId)
        formData.append('object_metadata', JSON.stringify({
          category,
          title: metadataPrompt.value.title,
          description: metadataPrompt.value.description,
          file_name: file.name,
          file_type: uploadedFile.type,
        }))

        const apiDirectory = process.env.API_DIRECTORY
        await axios.post(`${apiDirectory}/upload-file`, formData)
        await this.fetchIncidentFiles()
        Swal.fire('Completado', 'Archivo subido correctamente.', 'success')
      } catch (error) {
        console.error('Error uploading incident file:', error)
        Swal.fire('Error', 'No se pudo subir el archivo.', 'error')
      } finally {
        this.uploadingMedia = false
      }
    },
    openFile(item) {
      if (!item?.preview_url) return
      window.open(item.preview_url, '_blank')
    },
    downloadFile(item) {
      if (!item?.preview_url) return
      const link = document.createElement('a')
      link.href = item.preview_url
      link.download = item.file_name || item.title || `archivo-${item.file_id}`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    downloadAllIncidentFiles() {
      const allFiles = [...this.imageFiles, ...this.documentFiles]
      if (!allFiles.length) {
        Swal.fire('Sin archivos', 'No hay archivos para descargar.', 'info')
        return
      }
      allFiles.forEach((item, index) => {
        setTimeout(() => this.downloadFile(item), index * 160)
      })
      Swal.fire('Completado', 'Se iniciaron las descargas de todos los archivos.', 'success')
    },
    async deleteIncidentFile(fileId) {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la incidencia.', 'warning')
        return
      }
      try {
        const result = await Swal.fire({
          title: 'Eliminar archivo',
          text: '¿Deseas eliminar este archivo?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar',
        })
        if (!result.isConfirmed) return
        const apiDirectory = process.env.API_DIRECTORY
        await axios.post(`${apiDirectory}/delete-file/`, { blob_id: fileId })
        await this.fetchIncidentFiles()
        Swal.fire('Completado', 'Archivo eliminado.', 'success')
      } catch (error) {
        console.error('Error deleting incident file:', error)
        Swal.fire('Error', 'No se pudo eliminar el archivo.', 'error')
      }
    },
    validateForm() {
      this.validationErrors.unit = !this.localIncident.unit
      this.validationErrors.accident_description = !this.localIncident.accident_description
      return !this.validationErrors.unit && !this.validationErrors.accident_description
    },
    async saveIncident() {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la incidencia.', 'warning')
        return
      }
      if (!this.validateForm()) {
        await Swal.fire('Faltan datos', 'Completa los campos obligatorios.', 'warning')
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      try {
        this.saving = true
        const payload = {
          ...this.localIncident,
          resolution_time: this.localIncident.resolution_time || null,
          authorities_involved: this.sanitizeList(this.authorities, ['authority', 'comments']),
          damages: this.sanitizeList(this.damagesList, ['type', 'comments']),
        }
        await axios.put(`${apiDirectory}/unit-incidents/${this.localIncident.id}/`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          background: '#d4edda',
          title: '¡Guardado!',
          text: 'La incidencia se actualizó correctamente.',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        })
        this.$emit('refresh-incident')
      } catch (error) {
        console.error('There was an error updating incident', error)
        Swal.fire('Error', error.message || 'No se pudo guardar la incidencia.', 'error')
      } finally {
        this.saving = false
      }
    },
    async completeIncident() {
      if (!this.canComplete) {
        Swal.fire('Sin acceso', 'No tienes permisos para completar la incidencia.', 'warning')
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      try {
        this.saving = true
        const payload = {
          ...this.localIncident,
          incident_status: 2,
          resolution_time: this.localIncident.resolution_time || null,
        }
        await axios.put(`${apiDirectory}/unit-incidents/${this.localIncident.id}/`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        this.localIncident.incident_status = 2
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          background: '#d4edda',
          title: '¡Completado!',
          text: 'La incidencia se marcó como solucionada.',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        })
        this.$emit('refresh-incident')
      } catch (error) {
        console.error('There was an error completing incident', error)
        Swal.fire('Error', 'No se pudo completar la incidencia.', 'error')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
/* Maintenance form styles */
.logo-button { height: 40px; }
.nav-bar-operations { height: 50px; }
.note-container { padding: 0 15px; }
.create-order { display: flex; padding: 5px 0; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap; }
.create-order button { padding: 5px 15px; background-color: #d5171d; color: white; border: none; border-radius: 7px; cursor: pointer; font-size: 14px; font-weight: 500; transition: .3s all; }
.create-order button:hover { background: black; }
.main-data-container { display: grid; grid-template-columns: repeat(14, minmax(0, 1fr)); gap: 12px; margin-top: 12px; }
.container-card { border: 1px solid #f3f3f3; border-radius: 0px; margin-bottom: 0px; border-top: none; }
.container-card-body { padding: 5px 8px; }
.title { background: #f2f7fa; padding: 5px 15px; border-radius: 0; display: flex; align-items: center; gap: 10px; }
.title h4 { font-size: 16px; text-align: left; line-height: 20px; margin-bottom: 0; font-weight: 700; }
.maintenance-title-row { justify-content: space-between; }
.maintenance-general { grid-column: span 10; }
.maintenance-side { grid-column: span 4; display: grid; gap: 12px; }
.maintenance-general-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 16px; }
.maintenance-column { display: grid; gap: 8px; }
.maintenance-main { grid-column: span 10; display: grid; gap: 12px; }
.form-input-group { display: flex; align-items: center; gap: 8px; }
.form-input-group label { min-width: 110px; margin: 0; }
.form-input-group.full-width { margin-top: 8px; }
input[type=text], input[type=number], input[type=datetime-local], select, textarea { padding: 1.5px 8px; width: 100%; font-size: 11px; border: 1px solid #ececec; border-radius: 5px; font-weight: 500; outline: none; margin-bottom: 0; }
input[type=text]:focus, input[type=number]:focus, input[type=datetime-local]:focus, select:focus, textarea:focus { border: 1px solid #ffc736; }
.form-input-group input, .form-input-group select, .form-input-group textarea { flex: 1; }
label { display: block; font-size: 11px; margin-bottom: 0; font-weight: 600; color: #929292; }
.form-input-group label { margin-top: 2px; }
textarea { min-height: 64px; resize: vertical; }
.invalid { border-color: #d9534f !important; background: #fff3f3; }
.form-actions { display: flex; justify-content: center; gap: 8px; padding: 12px 0 16px; }
.btn-submit-save { background-color: #2ada85; color: #fff; border: none; padding: 4px 12px; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 600; }
.btn-submit-cancel { background-color: #d5171d; color: #fff; border: none; padding: 4px 12px; border-radius: 6px; font-size: 12px; cursor: pointer; }
.btn-complete { background-color: #111827; }
.status {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px; border-radius: 999px; font-weight: 800; font-size: .85rem;
  border: 1px solid transparent;
}
.status--ok { background: #e8f7ef; color: #0f7a3b; border-color: #bde6cd; }
.status--warn { background: #fff6e5; color: #8a6100; border-color: #f2dfb2; }
.mini-action {
  border: 1px solid #ececec;
  background: #111827;
  color: #fff;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 11px;
  cursor: pointer;
}
.list-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f3f3f3;
}
.list-row:last-child { border-bottom: none; }
.mini-delete {
  border: none;
  background: #d5171d;
  color: #fff;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
}
.empty-row {
  font-size: 12px;
  color: #8a8a8a;
  padding: 6px 0;
}
.media-section { margin-bottom: 16px; }
.media-section:last-child { margin-bottom: 4px; }
.media-header h5 { margin: 6px 0 10px; font-size: 13px; font-weight: 900; text-align: left; }
.media-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 10px; }
.media-card {
  border: 1px solid #94a3b8;
  border-radius: 10px;
  background: #fff;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.media-add {
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #eff6ff;
  border-style: dashed;
  padding: 10px;
}
.media-add:disabled { cursor: not-allowed; opacity: .6; }
.media-plus { font-size: 42px; line-height: 1; font-weight: 900; color: #1d4ed8; }
.media-add-label { margin-top: 8px; font-size: 12px; font-weight: 800; color: #1e3a8a; }
.media-preview { width: 100%; height: 120px; object-fit: cover; background: #e2e8f0; }
.media-doc-icon {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #1e3a8a;
  font-size: 22px;
  font-weight: 900;
}
.media-meta { padding: 8px; display: grid; gap: 4px; flex: 1; }
.media-meta h6 { margin: 0; font-size: 12px; font-weight: 900; }
.media-meta p { margin: 0; font-size: 11px; color: #334155; word-break: break-word; }
.media-actions { padding: 0 8px 8px; display: flex; gap: 6px; }
.media-btn { flex: 1; padding: 6px 4px; font-size: 10px; }

.note-container {
  padding-top: 50px;
}
.nav-bar-operations {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>
